import { Obj3d } from './obj3d';
import * as THREE from 'three';

export class Varios3d extends Obj3d {

	// Constantes de los tipos de postes.
	public static readonly Muro = 'Muro';
	public static readonly PlacaBase = 'PlacaBase';
	public static readonly Espino = 'Espino';
	public static readonly TornaPuntasRecto = 'TornaPuntasRecto';
	public static readonly TornaPuntasRectoG = 'TornaPuntasRectoG';
	public static readonly TornaPuntasDerecho = 'TornaPuntasDerecho';
	public static readonly TornaPuntasDerechoG = 'TornaPuntasDerechoG';
	public static readonly TornaPuntasIzquierdo = 'TornaPuntasIzquierdo';
	public static readonly TornaPuntasIzquierdoG = 'TornaPuntasIzquierdoG';
	public static readonly Marcador = 'Marcador';

	private materialMarcador: THREE.MeshBasicMaterial;

	constructor(path: string, debug = false) {
		super(path, debug);

		this.materialMarcador = new THREE.MeshBasicMaterial({ color: 0xE792D8 });

		this._data = {
			Muro: { estado: 0, archivo: 'Muro', carpeta: 'varios', mesh: undefined, length: 1 },
			PlacaBase: { estado: 0, archivo: 'PlacaBase', carpeta: 'varios', mesh: undefined, length: 0 },
			Espino: { estado: 0, archivo: 'Espino', carpeta: 'varios', mesh: undefined, length: 1, uv: 4 },
			TornaPuntasRecto: { estado: 0, archivo: 'TornapuntasRecto', carpeta: 'varios', mesh: undefined, length: 0 },
			TornaPuntasRectoG: { estado: 0, archivo: 'TornapuntasRectoG', carpeta: 'varios', mesh: undefined, length: 0 },
			TornaPuntasDerecho: { estado: 0, archivo: 'TornapuntasDerecho', carpeta: 'varios', mesh: undefined, length: 0 },
			TornaPuntasDerechoG: { estado: 0, archivo: 'TornapuntasDerechoG', carpeta: 'varios', mesh: undefined, length: 0 },
			TornaPuntasIzquierdo: { estado: 0, archivo: 'TornapuntasIzquierdo', carpeta: 'varios', mesh: undefined, length: 0 },
			TornaPuntasIzquierdoG: { estado: 0, archivo: 'TornapuntasIzquierdoG', carpeta: 'varios', mesh: undefined, length: 0 },
			Marcador: { estado: 0, archivo: 'Marcador', carpeta: 'varios', mesh: undefined, length: 3 }
		};
	}

	// Clona un muro, por defecto devuelve un muro de un metro.
	public cloneWall(length = 1, height = 1) {
		// Asegurarse de que se cargo.
		if (!this._data[Varios3d.Muro].mesh) return undefined;
		let obj = this._data[Varios3d.Muro].mesh.clone();
		//obj.receiveShadow = true;
		//obj.castShadow = true;
		// Si hay petición de escalar.
		if (length != 1 || height != 1) {
			obj.scale.set(length, height, 1);
			obj.updateMatrix();
		}
		return obj;
	}

	// Marcador, cuando la cámara está a una distancia determinada los marcadores se hacen visibles.
	// Se rutiliza la mesh del muro con color rosado para destacar.
	public cloneMarcador() {
		// Asegurarse de que se cargo.
		if (!this._data[Varios3d.Marcador].mesh) return undefined;
		let obj = this._data[Varios3d.Marcador].mesh.clone();
		//obj.material = this.materialMarcador;
		obj.name = 'Marcador';
		return obj;
	}

	public clonePlacaBaseMaterial(colorStyle: string): any {
		let newMats = [];
		if (this._data['PlacaBase'].mesh) {
			let mats = this._data['PlacaBase'].mesh.children[0].material;
			for (let m = 0; m < mats.length; m++) {
				if (mats[m].name.startsWith('COL_')) {
					let aux = mats[m].clone();
					aux.color.setStyle(colorStyle);
					newMats.push(aux);
				}
				else newMats.push(mats[m]);
			}
		}
		return newMats;
	}

	public cloneEspino(x: number, height: number, length: number, direction = 1) {
		// Clonar.
		let bas = this._data[Varios3d.Espino].mesh.clone();

		let uv2 = (length * (this._data[Varios3d.Espino].uv / 100)) * 100;

		let child = bas.children[0];
		if (child.isMesh) {
			child.geometry = child.geometry.clone();
			let material = child.material.clone();
			material.map = Object.assign(child.material.map);
			child.material = material;

			// Escalar espino.
			let pos = child.geometry.attributes.position.array;
			for (let u = 0; u < pos.length; u += 3) { if (pos[u] > 0.12) pos[u] = length; }

			let uvs = child.geometry.attributes.uv.array;
			for (let u = 0; u < uvs.length; u += 2) { if (uvs[u] > 0.09) uvs[u] = uv2; }

			child.geometry.verticesNeedUpdate = true;
			child.geometry.elementsNeedUpdate = true;
			child.geometry.uvsNeedUpdate = true

			child.position.x = x;
			child.position.y = height;
			child.scale.z = direction;
		}

		return bas;
	}

	public cloneEspino2(pointA: THREE.Vector3, pointB: THREE.Vector3, height: number, direction: number) {
		// Clonar.
		let bas = this._data[Varios3d.Espino].mesh.clone();
		if (!bas) return undefined;

		let length = pointA.distanceTo(pointB);
		let uv2 = (length * (this._data[Varios3d.Espino].uv / 100)) * 100;

		let child = bas.children[0];
		if (child.isMesh) {
			child.geometry = child.geometry.clone();
			let material = child.material.clone();
			material.map = Object.assign(child.material.map);
			child.material = material;

			// Escalar espino.
			let salto = pointB.y - pointA.y;
			let pos = child.geometry.attributes.position.array;
			for (let u = 0; u < pos.length; u += 3) {
				if (pos[u] > 0.12) {
					pos[u] = length;
					pos[u + 1] += salto;
				}
			}

			let uvs = child.geometry.attributes.uv.array;
			for (let u = 0; u < uvs.length; u += 2) { if (uvs[u] > 0.09) uvs[u] = uv2; }

			child.geometry.verticesNeedUpdate = true;
			child.geometry.elementsNeedUpdate = true;
			child.geometry.uvsNeedUpdate = true;
		}

		bas.position.set(pointA.x, pointA.y + height, pointA.z);
		bas.scale.z = direction;

		return bas;
	}
}